// ============================================================
//  AI PLAY - KONFIGURACJA STRONY (EDYTUJ TYLKO TEN PLIK)
//  Ceny, linki, nazwy produktów, opinie, dane firmy, zdjęcia.
// ============================================================

// --- LINKI DO PAKIETÓW (wklej docelowe adresy zakupu) ---
export const LINKS = {
  aiPlay: "https://online.annapoplawska.pl/s/ai-speaking-games.html",
  aiPlaySzkola: "https://online.annapoplawska.pl/s/ai-speaking-games-mini-pakiet.html",
  kompletny: "https://online.annapoplawska.pl/s/ai-speaking-games-pakiet-kompletny.html",
  privacy: "https://annapoplawska.pl/politykaprywatnosci/",
  terms: "https://annapoplawska.pl/regulamin/",
  payments: "https://annapoplawska.pl/regulamin/", // informacje o płatnościach w regulaminie
};

// --- ZDJĘCIA I LOGO ---
// Pliki znajdują się w frontend/public/images/.
export const IMAGES = {
  logo: "/images/logo.png", // pełne logo (ap + anna popławska)
  logoMark: "/images/logo-mark.png", // sam znak "ap" do menu
  hero: "/images/anna-hero.webp",
  about: "/images/anna-about.webp",
  cta: "/images/anna-cta.webp",
};

// --- PAKIETY I CENY ---
export const PRICING = {
  installmentsNote: null, // np. "Dostępne 3 raty po 199 zł" - null ukrywa wiersz
  packages: [
    {
      id: "ai-play",
      name: "AI SPEAKING GAMES",
      badge: null,
      desc: "Dla nauczyciela, który chce tworzyć z AI gry dające uczniom powód do rozmowy.",
      thumbs: [
        { img: "/images/thumb-ai-speaking-games.webp", alt: "Okładka kursu AI Speaking Games" },
      ],
      intro: "Pakiet zawiera:",
      features: [
        "pełny kurs AI Speaking Games",
        "6 modułów",
        "50 pomysłów na gry i aktywności na speaking",
        "gotowe prompty do wykorzystania",
        "gry planszowe, karciane i handouty",
        "proste gry interaktywne w HTML",
      ],
      price: "419 zł",
      priceNote: null,
      presale: null,
      target: null,
      regularLabel: null,
      regular: null,
      savings: null,
      cta: "Wybieram AI Speaking Games",
      link: LINKS.aiPlay,
      featured: true,
    },
    {
      id: "ai-play-szkola",
      name: "AI SPEAKING GAMES + SZKOŁA AI",
      badge: null,
      desc: "Dla nauczyciela, który chce szerzej wykorzystać AI w codziennej pracy.",
      thumbs: [
        { img: "/images/thumb-ai-speaking-games.webp", alt: "Okładka kursu AI Speaking Games" },
        { img: "/images/thumb-szkola-ai.webp", alt: "Grafika kursu Szkoła AI dla nauczyciela" },
      ],
      intro: "Wszystko z pakietu AI Speaking Games, a także:",
      features: [
        "pełny kurs „Szkoła AI dla nauczyciela”",
        "szersze wykorzystanie AI w planowaniu lekcji, tworzeniu materiałów i pracy nauczyciela",
        "dodatkowe materiały należące do kursu Szkoła AI",
      ],
      price: "619 zł",
      priceNote: null,
      presale: null,
      target: null,
      regularLabel: null,
      regular: null,
      savings: null,
      cta: "Wybieram AI Speaking Games + Szkołę AI",
      link: LINKS.aiPlaySzkola,
      featured: false,
    },
    {
      id: "kompletny",
      name: "PAKIET KOMPLETNY",
      badge: null,
      desc: "Dla nauczyciela, który chce wszystko: kursy oraz ebooki z setkami gotowych pomysłów.",
      thumbs: [
        { img: "/images/thumb-ai-speaking-games.webp", alt: "Okładka kursu AI Speaking Games" },
        { img: "/images/thumb-szkola-ai.webp", alt: "Grafika kursu Szkoła AI dla nauczyciela" },
        { img: "/images/thumb-136-pomyslow.webp", alt: "Okładka ebooka 136 pomysłów na speaking" },
        { img: "/images/thumb-spice-up-your-class.webp", alt: "Okładka ebooka Spice Up Your Class" },
      ],
      intro: "Wszystko z pakietów 1 i 2, a także:",
      features: [
        "ebook „136 pomysłów na speaking”",
        "ebook „Spice Up Your Class” - bank 200+ pomysłów na świetne lekcje",
      ],
      price: "819 zł",
      priceNote: null,
      presale: null,
      target: null,
      regularLabel: null,
      regular: null,
      savings: null,
      cta: "Wybieram pakiet kompletny",
      link: LINKS.kompletny,
      featured: false,
    },
  ],
  footnote:
    "Każdy pakiet zawiera pełny kurs AI Speaking Games. Wybierasz wyłącznie zakres dodatkowych kursów i materiałów.",
  invoiceNote: "Potrzebujesz specjalnej faktury do szkoły? Napisz do nas:",
};

// --- OPINIE (prawdziwe opinie z Facebooka; nie numerujemy ich na stronie) ---
export const TESTIMONIALS = [
  {
    quote: "Jeżeli ktoś rozważa szkolenie z Anią, to niech się nie zastanawia, tylko bierze udział. Dzięki Ani znów chce się być nauczycielem. Dzięki Aniu! Jesteś fantastyczna.",
    name: "Larysa Kokoszka",
    role: "Opinia z Facebooka",
  },
  {
    quote: "Po szkoleniu moje zajęcia zostały wzbogacone o rewelacyjne strony internetowe i wiele niezwykle ciekawych pomysłów, jak wykorzystać je na zajęciach. Z całą pewnością jeszcze nie raz będę uczestniczką szkoleń Pani Anny, do czego zachęcam też inne osoby.",
    name: "Aleksandra Mierzejewska",
    role: "Opinia z Facebooka",
  },
  {
    quote: "Szkolenia Pani Ani to nie tylko kopalnia wiedzy o tym, jak wzbogacić zajęcia o technologiczne nowinki, które zadowolą zarówno dzieci, jak i dorosłych, ale też ogromna motywacja. Zachęcam wszystkich, bo optymizm i zapał Pani Ani uzależnia!",
    name: "Angelika Kazimierska",
    role: "Opinia z Facebooka",
  },
  {
    quote: "Bogu dziękować, że jest ktoś taki jak Ania. Nikt mnie chyba nie nauczył tylu ciekawych rzeczy co Ona. Uwielbiam Jej entuzjazm, pasję i chłonę wiedzę, którą przekazuje.",
    name: "Joanna Ostapowicz",
    role: "Opinia z Facebooka",
  },
  {
    quote: "Pani Ania Popławska zaraża pasją. Pokazuje mnóstwo rzeczy, których pewnie w życiu samodzielnie bym nie znalazła. Polecam szkolenia Ani, zarówno te na żywo, jak i online. Same praktyczne rzeczy, zero papierologii.",
    name: "Anna Król-Pawelska",
    role: "Opinia z Facebooka",
  },
  {
    quote: "Dzięki Ani, Jej webinariom i kursowi Praktyczny Trening zyskałam zupełnie nowe spojrzenie na pracę z technologią. Zaprezentowane narzędzia zrewolucjonizowały sposób, w jaki pomagam uczniom poprawić mówienie. Dzięki, Ania, na wieki!",
    name: "Agnieszka Cymbor",
    role: "Opinia z Facebooka",
  },
];

// --- FAQ - PYTANIA ORGANIZACYJNE ---
export const FAQ_ORG = [
  {
    q: "Kiedy odbywa się kurs?",
    a: "Kurs jest dostępny od ręki - po zakupie wyślemy Ci maila z dostępem do platformy. Wszystkie materiały i nagrania masz przez 10 miesięcy.",
  },
  {
    q: "Jak długo mam dostęp do kursu?",
    a: "Dostęp do kursu masz przez 10 miesięcy.",
  },
  {
    q: "Czy w kursie są gry do debat i dyskusji?",
    a: "Tak. Znajdziesz w nim m.in. karty ról z dokładnym scenariuszem, zadaniami i przydatnymi zwrotami - także do debat, w których uczniowie przekonują do swojego zdania.",
  },
];

// --- WYDARZENIE NA ŻYWO ---
export const LIVE = {
  date: "Kurs dostępny od ręki",
  note: "Wszystkie materiały i nagrania są już dostępne na platformie.",
};

// --- EARLY BIRD (licznik; czas warszawski) ---
export const PRESALE = {
  end: "2026-10-21T23:59:59+02:00",
  text: "Koniec ceny early bird: 21 października",
  deadlineNote: "Ceny early bird obowiązują tylko do 21 października",
};

// --- STRONA PODZIĘKOWANIA (/dziekuje) ---
export const THANKYOU = {
  code: "AP10",
  shopUrl: "https://annapoplawska.pl",
};

// --- STOPKA / DANE FIRMY ---
export const FOOTER = {
  company: "POPŁAWSKA TEACHER DEVELOPMENT & EDUCONSULTING",
  address: "ul. Ludwika Rydygiera 11/U7, 01-793 Warszawa",
  krs: "0001127997",
  nip: "5273130684",
  email: "anna@annapoplawska.pl",
  phone: "+48 661 06 720",
  copyright: `© ${new Date().getFullYear()} Anna Popławska. Wszelkie prawa zastrzeżone.`,
};

// ============================================================
//  TREŚCI STAŁE KURSU (edytuj tylko przy realnej zmianie oferty)
// ============================================================

export const STATS = [
  { value: 17, suffix: "+", label: "lat doświadczenia w nauczaniu" },
  { value: 14, prefix: "~", label: "lat doświadczenia w szkoleniu nauczycieli" },
  { value: 5000, suffix: "+", label: "przeszkolonych nauczycieli" },
];

export const PILLARS = [
  {
    n: "01",
    title: "Cel i metodyka",
    text: "Jak dobierać gry, które pomagają uczniom rozwijać wypowiedzi, zadawać pytania i reagować na to, co mówią inni.",
    color: "magenta",
  },
  {
    n: "02",
    title: "Dobry prompt",
    text: "Jak przekazać AI cel językowy, poziom i potrzeby grupy, żeby stworzyć grę, która daje uczniom powód do rozmowy.",
    color: "cyan",
  },
  {
    n: "03",
    title: "Gotowa gra",
    text: "Jak przygotować karty, zasady i wsparcie językowe, żeby uczniowie szybko zaczęli grać i mówić w języku obcym.",
    color: "violet",
  },
];

export const STEPS = [
  { n: "1", title: "Cel językowy", text: "Określasz, co uczniowie mają ćwiczyć: zadawanie pytań, opowiadanie, wyrażanie opinii czy negocjowanie." },
  { n: "2", title: "Pomysł na rozmowę", text: "Wybierasz krótką aktywność: zagadkę, karty ról, zgadywankę albo zadanie z brakującymi informacjami." },
  { n: "3", title: "Prompt do AI", text: "Podajesz temat, poziom grupy i czas. Prosisz AI o konkretne materiały, proste zasady i przydatne zwroty." },
  { n: "4", title: "Sprawdzenie i poprawki", text: "Sprawdzasz język, polecenia i to, czy zadanie zachęca do rozmowy. Dopasowujesz materiał do swoich uczniów." },
  { n: "5", title: "Materiał na lekcję", text: "Masz gotowe karty, ilustrację lub krótkie zadanie do wydrukowania albo wyświetlenia. Uczniowie pracują w parach lub grupach i rozmawiają." },
];

export const OUTCOMES = [
  "dobierać gry i krótkie aktywności do konkretnego celu językowego",
  "pisać prompty, dzięki którym AI przygotuje materiały na speaking",
  "zamieniać ćwiczenia z podręcznika w zadania wymagające rozmowy",
  "tworzyć gry, w których uczniowie używają poznanego słownictwa i gramatyki",
  "wykorzystywać zdjęcia, teksty i filmy jako punkt wyjścia do mówienia",
  "przygotowywać karty ról, zagadki i zadania z brakującymi informacjami",
  "planować pracę w parach i grupach tak, żeby każdy miał okazję mówić",
  "dopasowywać aktywności do wieku, poziomu i zainteresowań uczniów",
  "tworzyć podpowiedzi i przydatne zwroty, które ułatwiają udział w rozmowie",
  "sprawdzać poprawność językową i sens metodyczny materiałów AI",
  "upraszczać zasady i zmieniać zadania, które kończą się po jednym zdaniu",
  "budować własną bazę promptów i materiałów do wykorzystania na kolejnych lekcjach",
];

export const MODULES = [
  {
    title: "Od pomysłu do rozmowy",
    text: "Jak przygotować grę, która ma prosty przebieg i konkretny cel językowy.",
    lessons: [
      { t: "Co sprawia, że uczniowie chcą mówić?", d: "Cel, ciekawość, brakująca informacja i zadanie do wykonania." },
      { t: "Od celu językowego do pomysłu na grę", d: "Dobieranie aktywności do ćwiczenia pytań, opowiadania, opinii i reagowania." },
      { t: "Prompt, który uwzględnia Twoją grupę", d: "Jak określić poziom, wiek, temat, czas i oczekiwany materiał." },
      { t: "Pierwsza gra z AI krok po kroku", d: "Od polecenia do gotowych kart: sprawdzanie języka, zasad i przydatności zadania." },
    ],
  },
  {
    title: "Gry, które pomagają zacząć mówić",
    text: "Pomysły na krótkie aktywności, które angażują uczniów od początku lekcji i pomagają im nabrać pewności w mówieniu.",
    lessons: [
      { t: "Rozgrzewki językowe i aktywności integrujące grupę." },
      { t: "Gry rozwijające zadawanie pytań i reagowanie na odpowiedzi." },
      { t: "Utrwalanie słownictwa i gramatyki w krótkich rozmowach." },
      { t: "Sposoby na wydłużanie wypowiedzi i zachęcanie do dopytywania." },
    ],
  },
  {
    title: "Gry oparte na współpracy i interakcji",
    text: "Aktywności, w których uczniowie potrzebują rozmowy, żeby zdobyć informacje, podjąć decyzję lub osiągnąć wspólny cel.",
    lessons: [
      { t: "Wymiana informacji i uważne słuchanie rozmówcy." },
      { t: "Odgrywanie ról i komunikacja w różnych sytuacjach." },
      { t: "Wyrażanie opinii, argumentowanie i negocjowanie." },
      { t: "Wspólne rozwiązywanie problemów i podejmowanie decyzji." },
    ],
  },
  {
    title: "Obrazy, historie i zagadki na speakingu",
    text: "Pomysły na wykorzystanie ciekawości i wyobraźni do rozwijania dłuższych, bardziej samodzielnych wypowiedzi.",
    lessons: [
      { t: "Materiały wizualne jako impuls do rozmowy." },
      { t: "Opisywanie, porównywanie i interpretowanie." },
      { t: "Przewidywanie, formułowanie hipotez i uzasadnianie przypuszczeń." },
      { t: "Tworzenie i rozwijanie historii w parach i grupach." },
    ],
  },
  {
    title: "Gry decyzyjne i dyskusyjne",
    text: "Sposoby na tworzenie aktywności komunikacyjnych na podstawie materiałów i treści, z którymi już pracujesz.",
    lessons: [
      { t: "Przekształcanie ćwiczeń z podręcznika w aktywności na speaking." },
      { t: "Wykorzystywanie tekstów, nagrań i filmów do rozmowy." },
      { t: "Gry utrwalające słownictwo i struktury z wybranego działu." },
      { t: "Powtórki, które łączą poznany materiał z samodzielnym mówieniem." },
    ],
  },
  {
    title: "Plansze, karty i gry interaktywne",
    text: "Jak z pomocą AI nadać pomysłom na speaking różne formy i przygotować gotowe materiały na lekcję.",
    lessons: [
      { t: "Gry planszowe na speaking", d: "Tworzenie plansz, zadań i prostych zasad, które zachęcają do rozmowy i ćwiczenia wybranego języka." },
      { t: "Gry karciane i materiały do wycięcia", d: "Przygotowywanie zestawów kart do pracy w parach i grupach, dopasowanych do celu i poziomu zajęć." },
      { t: "Zwykły handout jako gra", d: "Wykorzystywanie jednej karty pracy do aktywności opartych na pytaniach, wymianie informacji i wspólnym działaniu." },
      { t: "Proste gry interaktywne w HTML", d: "Przygotowywanie z pomocą AI krótkich aktywności uruchamianych w przeglądarce, z kartami, losowaniem i zadaniami do mówienia." },
    ],
  },
];

export const TOOLKIT_INTRO =
  "50 pomysłów na gry i aktywności na speaking oraz konkretne przykłady ich przygotowania z AI. Krok po kroku pokażę Ci, jak tworzyć materiały dopasowane do tematu lekcji, poziomu i potrzeb Twoich uczniów.";

export const TOOLKIT = [
  { title: "Praktyczne lekcje wideo", desc: "Cały proces: od pomysłu i pierwszego promptu po gotowy materiał na lekcję." },
  { title: "50 pomysłów na gry i aktywności na speaking", desc: "Różnorodne sposoby na rozwijanie mówienia w parach i grupach." },
  { title: "Gotowe prompty do wykorzystania", desc: "Polecenia, które dostosujesz do swojego tematu, języka i poziomu grupy." },
  { title: "Gry planszowe i karciane", desc: "Przykłady plansz i zestawów kart, które dają uczniom powód do rozmowy." },
  { title: "Pomysły na gry ze zwykłego handoutu", desc: "Sposoby na zamianę karty pracy w angażującą aktywność komunikacyjną." },
  { title: "Proste gry interaktywne w HTML", desc: "Krótkie aktywności do mówienia, które uruchomisz w przeglądarce." },
  { title: "Warianty dla różnych grup", desc: "Sposoby dopasowania gier do wieku, poziomu, liczby uczniów i czasu na lekcji." },
  { title: "Wsparcie językowe do aktywności", desc: "Przydatne zwroty, początki zdań i podpowiedzi ułatwiające udział w rozmowie." },
  { title: "Wskazówki do sprawdzania i poprawiania materiałów", desc: "Na co zwrócić uwagę i jak poprosić AI o konkretne zmiany." },
];

export const TOOLKIT_HIGHLIGHT = {
  title: "Zobaczysz, jak to powstaje",
  desc: "Pokażę Ci pierwsze prompty, odpowiedzi AI i poprawki, dzięki którym materiał staje się gotowy do wykorzystania z uczniami.",
};

export const AUDIENCE_INTRO =
  "Dla nauczycieli języków obcych, którzy chcą dać uczniom więcej okazji do mówienia i tworzyć z AI materiały dopasowane do swoich lekcji.";

export const AUDIENCE = [
  { title: "Uczysz dzieci", desc: "Szukasz prostych gier, które angażują i zachęcają do pierwszych rozmów w języku obcym." },
  { title: "Uczysz nastolatków", desc: "Potrzebujesz pomysłów, które budzą ciekawość i dają uczniom coś ciekawego do powiedzenia." },
  { title: "Uczysz dorosłych", desc: "Chcesz urozmaicić speaking zadaniami, w których uczniowie rozmawiają, współpracują i podejmują decyzje." },
  { title: "Prowadzisz zajęcia online", desc: "Szukasz materiałów do wyświetlenia i prostych aktywności interaktywnych wspierających rozmowę." },
  { title: "Prowadzisz zajęcia stacjonarne", desc: "Chcesz wykorzystywać plansze, karty i handouty do mówienia w parach i grupach." },
  { title: "Zaczynasz korzystać z AI", desc: "Potrzebujesz przykładów, gotowych promptów i wyjaśnień krok po kroku." },
  { title: "Korzystasz już z AI i chcesz rozwinąć swoje pomysły", desc: "Szukasz nowych sposobów na speaking i chcesz tworzyć gry z jasnym celem językowym, dopasowane do Twoich uczniów." },
];

export const GAMES = [
  {
    title: "The Missing Diamond",
    type: "Kryminał",
    desc: "Trzy osoby, trzy alibi, jeden diament. Uczniowie analizują dowody i rozmawiają.",
    img: "/images/game-missing-diamond.webp",
    alt: "Gra kryminalna The Missing Diamond - karty podejrzanych, paragon i dowody na biurku",
  },
  {
    title: "Our Trip",
    type: "Karty ról",
    desc: "Każdy ma tajny cel. Planujecie wspólną podróż i musicie dojść do porozumienia.",
    img: "/images/game-our-trip.webp",
    alt: "Gra w pary Our Trip - dwie osoby trzymają karty ról przy stole",
  },
  {
    title: "Debate Scenarios",
    type: "Karty ról ze scenariuszem",
    desc: "Dokładny scenariusz, zadania i przydatne zwroty dla każdej ze stron. Uczniowie wcielają się w role i przekonują do swojego zdania.",
    img: "/images/game-debate-dossiers.webp",
    alt: "Karty ról Debate Scenarios - dwie pozycje ze scenariuszem, argumentami i przydatnymi zwrotami",
  },
  {
    title: "The Mystery",
    type: "Zagadka ze wskazówkami",
    desc: "Koperta pełna tropów: notatka, mapa, zdjęcia. Grupa składa historię w całość.",
    img: "/images/game-the-mystery.webp",
    alt: "Gra The Mystery - koperta ze wskazówkami, mapa, zdjęcia i tajemnicza notatka",
  },
  {
    title: "Choose & Explain",
    type: "Gra interaktywna",
    desc: "Uczniowie wybierają jedną z opcji i uzasadniają swój wybór - runda za rundą, w przeglądarce.",
    img: "/images/game-choose-explain.webp",
    alt: "Interaktywna gra na mówienie Choose & Explain na ekranie laptopa - wybór między pociągiem a samolotem",
  },
  {
    title: "Va Banque",
    type: "Gra zespołowa",
    desc: "Kategorie, punkty i dylematy. Drużyny rywalizują, odpowiadając pełnymi zdaniami.",
    img: "/images/game-va-banque.webp",
    alt: "Interaktywna gra zespołowa Va Banque Money Edition na ekranie laptopa - kategorie pytań i punkty drużyn",
  },
];

export const FAQ = [
  {
    q: "Czy muszę dobrze znać AI?",
    a: "Nie. Wszystkie procesy są pokazane krok po kroku. Osoby korzystające już z AI nauczą się tworzyć bardziej precyzyjne polecenia i lepiej kontrolować rezultaty.",
  },
  {
    q: "Czy muszę umieć programować?",
    a: "Nie. W module dotyczącym gier interaktywnych uczestnik uczy się opisywać AI oczekiwane działanie gry, testować rezultat i prosić o poprawki.",
  },
  {
    q: "Czy w kursie znajdują się gotowe gry?",
    a: "Tak. Kurs zawiera przykłady, szablony i gotowe materiały. Najważniejszym efektem jest jednak umiejętność samodzielnego tworzenia i dostosowywania kolejnych gier.",
  },
  {
    q: "Czy kurs dotyczy wyłącznie gier cyfrowych?",
    a: "Nie. Kurs obejmuje zarówno materiały do druku, jak i gry interaktywne.",
  },
  {
    q: "Czy gry można wykorzystać z dorosłymi?",
    a: "Tak. Kurs pokazuje, jak dostosowywać mechaniki do dzieci, nastolatków i dorosłych.",
  },
  {
    q: "Czy pomysły można wykorzystać podczas nauczania różnych języków?",
    a: "Tak. Mechaniki i schematy promptów można dostosować do dowolnego języka.",
  },
  {
    q: "Czym różnią się trzy pakiety?",
    a: "Każdy zawiera pełny kurs AI Speaking Games. Drugi dodaje Szkołę AI dla nauczyciela, a trzeci - dwa ebooki: „136 pomysłów na speaking” oraz „Spice Up Your Class”.",
  },
  ...FAQ_ORG,
];

export const NAV_LINKS = [
  { label: "O kursie", href: "#o-kursie" },
  { label: "Czego się nauczysz", href: "#czego-sie-nauczysz" },
  { label: "Program", href: "#program" },
  { label: "Pakiety", href: "#pakiety" },
  { label: "O prowadzącej", href: "#o-prowadzacej" },
  { label: "FAQ", href: "#faq" },
];
